// extracted by mini-css-extract-plugin
module.exports = {"button":"TileFavoriteIcon_button_SHsKB","favorited":"TileFavoriteIcon_favorited_3-ZE3"};